import React, { Fragment } from 'react';
import ResourceProperty from '../../../../common/resource/ResourceProperty';
import { tzNormalizeDate } from '../../../../../utils/date';
import { DATE_TIME_FORMAT } from '../../../../../config/locale';
import Table from '../../../../common/Table';
import { DEFAULT_PAGE_SIZE } from '../../../../../config/constants';
import { ROUTE_SEGMENT_COLUMNS } from '../../../../../config/columns';
import { SEGMENT_PATH } from '../../../../../config/paths';
import { filterMethodCaseInsensitive } from '../../../../../utils/filter-methods';
import { routeBasicInformationPropTypes } from '../proptypes/RoutePropTypes';
import Checkbox from '../../../../common/forms/Checkbox';
import RouteCharacteristicsInformationResource from './RouteCharacteristicsInformationResource';

const RouteBasicInformationResource = ({
  id,
  name,
  description,
  lastUpdate,
  routeSegmentList,
  isOneWay,
  isMaciva,
  hotZone,
  coldZone,
  steepRoute,
  flatRoute,
  lengthType,
  numberOfDrivers,
  isNorthChico,
  active,
}) => (
  <>
    <ResourceProperty label="Nombre: ">{name || '-'}</ResourceProperty>
    <ResourceProperty label="Descripción: ">
      {description || '-'}
    </ResourceProperty>
    <ResourceProperty label="Número de Conductores: ">
      {numberOfDrivers || '-'}
    </ResourceProperty>
    <Fragment>
      <div>
        <Checkbox checked={isOneWay} /> Sólo Ida
      </div>
      <div>
        <Checkbox checked={isMaciva} /> Maciva
      </div>
    </Fragment>
    <div>
      <Checkbox checked={isOneWay} /> Sólo Ida
    </div>
    <div>
      <Checkbox checked={isMaciva} /> Maciva
    </div>
    <div>
      <Checkbox checked={isNorthChico} /> Pertenece a Norte Chico
    </div>
    <h3 className="mt-3">Segmentos</h3>
    <Table
      columns={ROUTE_SEGMENT_COLUMNS}
      data={routeSegmentList}
      defaultPageSize={
        routeSegmentList.length <= 10
          ? routeSegmentList.length
          : DEFAULT_PAGE_SIZE
      }
      showPagination={routeSegmentList.length > 10}
      manual={false}
      modelPath={SEGMENT_PATH}
      filterable
      openPathInNewTab
      navigateToModelOnRowClick
      modelId="segmentId"
      defaultFilterMethod={filterMethodCaseInsensitive}
    />
    <RouteCharacteristicsInformationResource
      hotZone={hotZone}
      coldZone={coldZone}
      steepRoute={steepRoute}
      flatRoute={flatRoute}
      lengthType={lengthType}
    />
    <div>
      <Checkbox checked={active} /> Activo
    </div>
    <h3 className="mt-3">Información interna</h3>
    <ResourceProperty label="ID: ">{id || '-'}</ResourceProperty>
    <ResourceProperty label="Fecha de última actualización: ">
      {tzNormalizeDate({
        date: lastUpdate,
        format: DATE_TIME_FORMAT,
      }) || '-'}
    </ResourceProperty>
  </>
);

RouteBasicInformationResource.propTypes = routeBasicInformationPropTypes;

export default RouteBasicInformationResource;
